import React, { Fragment, PropsWithChildren } from "react";
import { Link, useNavigate } from "react-router";
import { EtudeStep, getAppUrl } from "utils/defines";
import Button from "./shared/button";
import { Text } from "./shared/text";

export type BreadcrumbProps = {
  text: string;
  link: string;
  state?: any;
  step?: EtudeStep;
};

export type PageProps = PropsWithChildren<{
  breadCrumb?: Array<BreadcrumbProps>;
  title?: string;
}>;

export const Page: React.FC<PageProps> = ({ children, breadCrumb, title }) => {
  const navigate = useNavigate();

  return (
    <>
      <group
        data-background="main"
        data-color="white"
        data-space="10"
        data-align="center"
        data-direction="column"
        data-gap="20"
        data-sticky="top"
      >
        <group data-max-length="1440" data-direction="column" data-gap="5">
          <group data-gap="10" data-align="center">
            <Link to={getAppUrl("/")}>
              <Text data-opacity="70">FO_BANDEAU_SOFTWARE</Text>
            </Link>

            {breadCrumb?.map((item, i) => {
              return (
                <Fragment key={`${item.text}_${i}`}>
                  <icon data-icon-size="10">arrow_forward_ios</icon>
                  <Link to={item.link} state={item.state}>
                    {item.text}
                  </Link>
                </Fragment>
              );
            })}
            <icon data-icon-size="10">arrow_forward_ios</icon>
            <text>{title}</text>
          </group>

          <group data-gap="10" data-align="center">
            <Button
              icon="arrow_back"
              micro
              primary
              rounded
              data-border=""
              onClick={() => {
                navigate(-1);
              }}
            />
            <text data-text-size="x-large">{title}</text>
          </group>
        </group>
      </group>
      {children}
    </>
  );
};
